import Dictionary from "./DictionaryApp";
import Library from "./Library.png";

function App() {
  return (
    <div className="App">
      <header className="App-header"></header>
      <img src={Library} className="App-logo" alt="logo" />
      <main>
        <Dictionary defaultKeyword="knowledge" />
      </main>
      <footer className="text-center">
        Coded by{" "}
        <a href="https://github.com/xshandy" target="_blank" rel="noreferrer">
          Shandy Shek
        </a>
      </footer>
    </div>
  );
}
export default App;
